import Header from "@shared/Header";
import React, { useState } from "react";
import { useParams} from 'react-router-dom';

export default function Refresh() {
  const {connectedAccountId} = useParams();
  const [accountLinkCreatePending, setAccountLinkCreatePending] = useState(false);
  const [error, setError] = useState(false);

  React.useEffect(() => {
    if (connectedAccountId) {
      setAccountLinkCreatePending(true);
      callStripeAccountLinkApi({
        account: connectedAccountId,
      })
        .then((json) => {
          setAccountLinkCreatePending(false);

          const { data: {url, error} } = json;

          if (url) {
            window.location.href = url;
          }

          if (error) {
            setError(true);
          }
        });
    }
  }, [connectedAccountId])

  return (
    <>
    <Header/>
    <div className="container" 
    style={{
      display:"flex",
      flexDirection:"column", 
      justifyContent:'center',
      alignItems:"center", 
      height:"88vh",
      }}
    >
      <div className="banner">
        <h2>"Unfortunately, you were unable to complete the onboarding process."</h2>
      </div>
      {/* <div className="content">
        <h2>Add information to start accepting money</h2>
        <p>IBIZ TECHNOVA INC is the world's leading air travel platform: join our team of pilots to help people travel faster.</p>
        {error && <p className="error">Something went wrong!</p>}
      </div> */}
      {/* <div className="dev-callout">
        {connectedAccountId && <p>Your connected account ID is: <code className="bold">{connectedAccountId}</code></p>}
        {accountLinkCreatePending && <p>Creating a new Account Link...</p>}
      </div> */}
    </div>
    </>
  );
}